import { addSignatureModal } from "./addSignatureModal";

export const MIGRATIONS_DEBUG = true;
export const migrations = {
  0: (state) => state,
  1: (state) => state,
  2: addSignatureModal,
}